import { type Meta } from '../types/docs';
import { WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM } from './workspaceAgentAnalytics';

export const WORKSPACE_AGENT_CONTEXT_OPENED_METHODS = ['keyboard', 'button'] as const;

export type WorkspaceAgentContextOpenedMethod = (typeof WORKSPACE_AGENT_CONTEXT_OPENED_METHODS)[number];

const META: Meta = {
  description: 'The composer @ mention context picker opens',
  name: 'agent_context_opened',
  params: [
    WORKSPACE_AGENT_ANALYTICS_CATEGORY_META_PARAM,
    {
      description:
        'Whether the picker was opened by typing @ or clicking the Add reference row in the Actions menu (button)',
      name: 'method',
      required: true,
      type: 'enum',
      values: [...WORKSPACE_AGENT_CONTEXT_OPENED_METHODS],
    },
  ],
};

export default META;
